export default fields => {
  const invoiceTypeElement = fields.invoiceType;
  const knowledgeOfConsumptionElement = fields.knowledgeOfConsumption;
  const dayConsumptionElement = fields.dayConsumption;
  const nightConsumptionElement = fields.nightConsumption;
  const levelOfConsumptionElement = fields.levelOfConsumption;
  const postalCodeElement = fields.postalCode;
  const standingOrderElement = fields.standingOrder;
  const corporateNameElement = fields.corporateName;
  const customerFirstNameElement = fields.customerFirstName;
  const customerLastNameElement = fields.customerLastName;
  const customerMobilePhoneNumberElement = fields.customerMobilePhoneNumber;
  const currentSupplierElement = fields.currentSupplier;
  const currentProductElement = fields.currentProduct;
  const termsAndPoliciesAgreementElement = fields.termsAndPoliciesAgreement;
  const capacityChargeElement = fields.capacityCharge;

  return {
    type: "object",
    definitions: {
      currentSupplier: {
        type: "string",
        title: currentSupplierElement.label,
        enum: [],
        enumNames: [],
        helpTitle: currentSupplierElement.helpTitle,
        helpText: currentSupplierElement.helpText,
        helpExampleImageUrl: currentSupplierElement.helpExampleImageUrl,
        searchable: currentSupplierElement.searchable,
        searchableNoOptionFoundMessage:
          currentSupplierElement.searchableNoOptionFoundMessage
      },
      currentProduct: {
        type: "string",
        title: currentProductElement.label,
        enum: [],
        enumNames: [],
        helpTitle: currentProductElement.helpTitle,
        helpText: currentProductElement.helpText,
        helpExampleImageUrl: currentProductElement.helpExampleImageUrl,
        searchable: currentProductElement.searchable,
        searchableNoOptionFoundMessage:
          currentProductElement.searchableNoOptionFoundMessage
      },
      corporateName: {
        type: "string",
        title: corporateNameElement.label,
        helpTitle: corporateNameElement.helpTitle,
        helpText: corporateNameElement.helpText
      },
      customerFirstName: {
        type: "string",
        title: customerFirstNameElement.label,
        helpTitle: customerFirstNameElement.helpTitle,
        helpText: customerFirstNameElement.helpText
      },
      customerLastName: {
        type: "string",
        title: customerLastNameElement.label,
        helpTitle: customerLastNameElement.helpTitle,
        helpText: customerLastNameElement.helpText
      },
      customerMobilePhoneNumber: {
        type: "string",
        pattern: "^(69\\d{8})?$",
        maxLength: 10,
        title: customerMobilePhoneNumberElement.label,
        helpTitle: customerMobilePhoneNumberElement.helpTitle,
        helpText: customerMobilePhoneNumberElement.helpText
      },
      termsAndPoliciesAgreement: {
        type: "boolean",
        title: termsAndPoliciesAgreementElement.label,
        helpTitle: termsAndPoliciesAgreementElement.helpTitle,
        helpText: termsAndPoliciesAgreementElement.helpText,
        enum: [true]
      }
    },
    properties: {
      invoiceType: {
        type: "string",
        title: invoiceTypeElement.label,
        enum: invoiceTypeElement.enum,
        enumNames: invoiceTypeElement.enumNames,
        helpTitle: invoiceTypeElement.helpTitle,
        helpText: invoiceTypeElement.helpText,
        helpExampleImageUrl: invoiceTypeElement.helpExampleImageUrl,
        default: "g21"
      }
    },
    required: ["invoiceType"],
    dependencies: {
      currentSupplier: {
        oneOf: [
          {
            properties: {
              currentSupplier: {
                enum: [""]
              }
            }
          },
          {
            properties: {
              currentSupplier: {
                enum: []
              },
              currentProduct: { $ref: "#/definitions/currentProduct" }
            },
            required: ["currentProduct"]
          }
        ]
      },
      invoiceType: {
        oneOf: [
          {
            properties: {
              invoiceType: {
                enum: ["g21"]
              },
              currentSupplier: { $ref: "#/definitions/currentSupplier" },
              knowledgeOfConsumption: {
                type: "boolean",
                title: knowledgeOfConsumptionElement.label,
                enum: knowledgeOfConsumptionElement.enum,
                enumNames: knowledgeOfConsumptionElement.enumNames,
                helpTitle: knowledgeOfConsumptionElement.helpTitle,
                helpText: knowledgeOfConsumptionElement.helpText,
                helpExampleImageUrl:
                  knowledgeOfConsumptionElement.helpExampleImageUrl,
                default: true
              },
              dayConsumption: {
                type: "number",
                title: dayConsumptionElement.label,
                helpTitle: dayConsumptionElement.helpTitle,
                helpText: dayConsumptionElement.helpText,
                helpExampleImageUrl: dayConsumptionElement.helpExampleImageUrl,
                minimum: dayConsumptionElement.minimum
              },
              standingOrder: {
                type: "boolean",
                title: standingOrderElement.label,
                enum: standingOrderElement.enum,
                enumNames: standingOrderElement.enumNames,
                helpTitle: standingOrderElement.helpTitle,
                helpText: standingOrderElement.helpText,
                helpExampleImageUrl: standingOrderElement.helpExampleImageUrl
              },
              postalCode: {
                type: "string",
                title: postalCodeElement.label,
                enum: postalCodeElement.enum,
                enumNames: postalCodeElement.enumNames,
                helpTitle: postalCodeElement.helpTitle,
                helpText: postalCodeElement.helpText,
                helpExampleImageUrl: postalCodeElement.helpExampleImageUrl,
                searchable: postalCodeElement.searchable,
                searchableNoOptionFoundMessage:
                  postalCodeElement.searchableNoOptionFoundMessage
              }
            },
            required: ["knowledgeOfConsumption", "dayConsumption", "postalCode"]
          },
          {
            properties: {
              invoiceType: {
                enum: ["g23"]
              },
              currentSupplier: { $ref: "#/definitions/currentSupplier" },
              knowledgeOfConsumption: {
                type: "boolean",
                title: knowledgeOfConsumptionElement.label,
                enum: knowledgeOfConsumptionElement.enum,
                enumNames: knowledgeOfConsumptionElement.enumNames,
                helpTitle: knowledgeOfConsumptionElement.helpTitle,
                helpText: knowledgeOfConsumptionElement.helpText,
                helpExampleImageUrl:
                  knowledgeOfConsumptionElement.helpExampleImageUrl,
                default: true
              },
              dayConsumption: {
                type: "number",
                title: dayConsumptionElement.labelNight,
                helpTitle: dayConsumptionElement.helpTitle,
                helpText: dayConsumptionElement.helpText,
                helpExampleImageUrl: dayConsumptionElement.helpExampleImageUrl,
                minimum: dayConsumptionElement.minimum
              },
              nightConsumption: {
                type: "number",
                title: nightConsumptionElement.label,
                helpTitle: nightConsumptionElement.helpTitle,
                helpText: nightConsumptionElement.helpText,
                helpExampleImageUrl:
                  nightConsumptionElement.helpExampleImageUrl,
                minimum: nightConsumptionElement.minimum
              },
              standingOrder: {
                type: "boolean",
                title: standingOrderElement.label,
                enum: standingOrderElement.enum,
                enumNames: standingOrderElement.enumNames,
                helpTitle: standingOrderElement.helpTitle,
                helpText: standingOrderElement.helpText,
                helpExampleImageUrl: standingOrderElement.helpExampleImageUrl
              },
              postalCode: {
                type: "string",
                title: postalCodeElement.label,
                enum: postalCodeElement.enum,
                enumNames: postalCodeElement.enumNames,
                helpTitle: postalCodeElement.helpTitle,
                helpText: postalCodeElement.helpText,
                helpExampleImageUrl: postalCodeElement.helpExampleImageUrl,
                searchable: postalCodeElement.searchable,
                searchableNoOptionFoundMessage:
                  postalCodeElement.searchableNoOptionFoundMessage
              }
            },
            required: [
              "knowledgeOfConsumption",
              "dayConsumption",
              "nightConsumption",
              "postalCode"
            ]
          },
          {
            properties: {
              invoiceType: {
                enum: ["g22"]
              },
              knowledgeOfConsumptionForLead: {
                type: "boolean",
                title: knowledgeOfConsumptionElement.label,
                enum: knowledgeOfConsumptionElement.enum,
                enumNames: knowledgeOfConsumptionElement.enumNames,
                helpTitle: knowledgeOfConsumptionElement.helpTitle,
                helpText: knowledgeOfConsumptionElement.helpText,
                helpExampleImageUrl:
                  knowledgeOfConsumptionElement.helpExampleImageUrl,
                default: true
              }
            },
            required: ["knowledgeOfConsumptionForLead"]
          },
          {
            properties: {
              invoiceType: {
                enum: ["bx", "by", "bg", "unknown"]
              },
              corporateName: {
                type: "string",
                title: corporateNameElement.label,
                helpTitle: corporateNameElement.helpTitle,
                helpText: corporateNameElement.helpText
              },
              customerFirstName: {
                type: "string",
                title: customerFirstNameElement.label,
                helpTitle: customerFirstNameElement.helpTitle,
                helpText: customerFirstNameElement.helpText
              },
              customerLastName: {
                type: "string",
                title: customerLastNameElement.label,
                helpTitle: customerLastNameElement.helpTitle,
                helpText: customerLastNameElement.helpText
              },
              customerMobilePhoneNumber: {
                type: "string",
                pattern: "^(69\\d{8})?$",
                maxLength: 10,
                title: customerMobilePhoneNumberElement.label,
                helpTitle: customerMobilePhoneNumberElement.helpTitle,
                helpText: customerMobilePhoneNumberElement.helpText
              },
              termsAndPoliciesAgreement: {
                type: "boolean",
                title: termsAndPoliciesAgreementElement.label,
                helpTitle: termsAndPoliciesAgreementElement.helpTitle,
                helpText: termsAndPoliciesAgreementElement.helpText,
                enum: [true]
              }
            },
            required: [
              "corporateName",
              "customerFirstName",
              "customerLastName",
              "customerMobilePhoneNumber",
              "termsAndPoliciesAgreement"
            ]
          }
        ]
      },
      knowledgeOfConsumptionForLead: {
        oneOf: [
          {
            properties: {
              knowledgeOfConsumptionForLead: {
                enum: [true]
              },
              capacityCharge: {
                type: "number",
                title: capacityChargeElement.label,
                helpTitle: capacityChargeElement.helpTitle,
                helpText: capacityChargeElement.helpText,
                helpTextKnownConsumption:
                  capacityChargeElement.helpTextKnownConsumption,
                helpExampleImageUrl:
                  capacityChargeElement.helpExampleImageUrl,
                minimum: capacityChargeElement.minimum
              },
              currentSupplier: { $ref: "#/definitions/currentSupplier" },
              dayConsumption: {
                type: "number",
                title: dayConsumptionElement.labelMonthly,
                helpTitle: dayConsumptionElement.helpTitleMonthly,
                helpText: dayConsumptionElement.helpTextKnownConsumptionMonthly,
                helpExampleImageUrl: dayConsumptionElement.helpExampleImageUrlMonthly,
                minimum: dayConsumptionElement.minimum
              },
              standingOrder: {
                type: "boolean",
                title: standingOrderElement.label,
                enum: standingOrderElement.enum,
                enumNames: standingOrderElement.enumNames,
                helpTitle: standingOrderElement.helpTitle,
                helpText: standingOrderElement.helpText,
                helpExampleImageUrl: standingOrderElement.helpExampleImageUrl
              },
              postalCode: {
                type: "string",
                title: postalCodeElement.label,
                enum: postalCodeElement.enum,
                enumNames: postalCodeElement.enumNames,
                helpTitle: postalCodeElement.helpTitle,
                helpText: postalCodeElement.helpText,
                helpExampleImageUrl: postalCodeElement.helpExampleImageUrl,
                searchable: postalCodeElement.searchable,
                searchableNoOptionFoundMessage:
                  postalCodeElement.searchableNoOptionFoundMessage
              }
            },
            required: [
              "dayConsumption",
              "postalCode",
              "capacityCharge"
            ]
          },
          {
            properties: {
              knowledgeOfConsumptionForLead: {
                enum: [false]
              },
              corporateName: { $ref: "#/definitions/corporateName" },
              customerFirstName: { $ref: "#/definitions/customerFirstName" },
              customerLastName: { $ref: "#/definitions/customerLastName" },
              customerMobilePhoneNumber: {
                $ref: "#/definitions/customerMobilePhoneNumber"
              }
            },
            required: [
              "corporateName",
              "customerFirstName",
              "customerLastName",
              "customerMobilePhoneNumber"
            ]
          }
        ]
      },
      knowledgeOfConsumption: {
        oneOf: [
          {
            properties: {
              knowledgeOfConsumption: {
                enum: [true]
              }
            }
          },
          {
            properties: {
              knowledgeOfConsumption: {
                enum: [false]
              },
              levelOfConsumption: {
                type: "string",
                title: levelOfConsumptionElement.label,
                enum: levelOfConsumptionElement.enum,
                enumNames: levelOfConsumptionElement.enumNames,
                helpTitle: levelOfConsumptionElement.helpTitle,
                helpText: levelOfConsumptionElement.helpText,
                helpExampleImageUrl:
                  levelOfConsumptionElement.helpExampleImageUrl
              }
            },
            required: ["levelOfConsumption"]
          }
        ]
      }
    },
    errorMessages: {
      knowledgeOfConsumption: {
        ...knowledgeOfConsumptionElement.errorMessages
      },
      knowledgeOfConsumptionForLead: {
        ...knowledgeOfConsumptionElement.errorMessages
      },
      capacityCharge: {
        ...capacityChargeElement.errorMessages
      },
      levelOfConsumption: {
        ...levelOfConsumptionElement.errorMessages
      },
      dayConsumption: {
        ...dayConsumptionElement.errorMessages
      },
      nightConsumption: {
        ...nightConsumptionElement.errorMessages
      },
      standingOrder: {
        ...standingOrderElement.errorMessages
      },
      postalCode: {
        ...postalCodeElement.errorMessages
      },
      corporateName: {
        ...corporateNameElement.errorMessages
      },
      customerFirstName: {
        ...customerFirstNameElement.errorMessages
      },
      customerLastName: {
        ...customerLastNameElement.errorMessages
      },
      customerMobilePhoneNumber: {
        ...customerMobilePhoneNumberElement.errorMessages
      },
      invoiceType: {
        ...invoiceTypeElement.errorMessages
      },
      termsAndPoliciesAgreement: {
        ...termsAndPoliciesAgreementElement.errorMessages
      },
      currentProduct: {
        ...currentProductElement.errorMessages
      }
    }
  };
};
